import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { useTypedSelector } from '../common';
import { LayoutComponent } from '../pages/Layout';
import { getUserSelector } from "../store/user";

import AuthRoutes from './AuthRoutes';
import NotAuthRoutes from './NotAuthRoutes';

const Router: FC = () => {
	const { accessToken } = useTypedSelector(getUserSelector);

	return (
		<BrowserRouter basename="/">
			{accessToken ? (
				<LayoutComponent>
					<AuthRoutes />
				</LayoutComponent>
			) : (
				<NotAuthRoutes />
			)}
		</BrowserRouter>
	);
};

export default Router;